import { useTranslation } from 'react-i18next';
import { Home, Wrench, Calculator, Briefcase, HelpCircle } from 'lucide-react';

interface BottomNavProps {
  activeSection: string;
  onNavigate: (section: string) => void;
}

export default function BottomNav({ activeSection, onNavigate }: BottomNavProps) {
  const { t } = useTranslation();

  const navItems = [
    { id: 'hero', label: t('nav.home'), icon: Home },
    { id: 'services', label: t('nav.services'), icon: Wrench },
    { id: 'calculator', label: t('nav.calculator'), icon: Calculator },
    { id: 'portfolio', label: t('nav.work'), icon: Briefcase },
    { id: 'faq', label: t('nav.faq'), icon: HelpCircle },
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 h-16 glass-nav z-50" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <div className="flex items-center justify-around h-full max-w-lg mx-auto px-2">
        {navItems.map((item) => {
          const isActive = activeSection === item.id;
          const Icon = item.icon;
          return (
            <button key={item.id} onClick={() => onNavigate(item.id)}
              className="flex flex-col items-center justify-center gap-0.5 w-14 h-14 relative transition-all duration-200">
              {isActive && <div className="absolute -top-0 left-1/2 -translate-x-1/2 w-5 h-[2px] bg-[#00D4FF] rounded-full" />}
              <Icon size={20} className={`transition-all duration-200 ${isActive ? 'text-[#00D4FF]' : 'text-[#B5BBC9]'}`} />
              <span className={`text-[10px] font-medium transition-colors ${isActive ? 'text-[#00D4FF]' : 'text-[#B5BBC9]'}`}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
